
@if (vars.pageLayoutConfig().showHeader) {
  <app-header/>
}

@if (vars.pageLayoutConfig().showHeaderV2) {
  <app-header-v2 />
}

@if (isSidebarOpened()) {
  <div class="blur-bg" (click)="closeProfileSidebar()"></div>
}

<router-outlet />

@if (vars.pageLayoutConfig().showFooter) {
  <app-footer />
}
@if (vars.pageLayoutConfig().showMiniFooter) {
  <app-mini-footer/>
}